import React from "react";
import {
  FeatherCheckCircle,
  FeatherClock,
  FeatherAlertCircle,
} from "@subframe/core";

interface StatusBadgeProps {
  status:
    | "completed"
    | "in_progress"
    | "pending_review"
    | "not_started"
    | "closed"
    | "open"
    | "done"
    | "approved"
    | "rejected"
    | "submitted_for_review"
    | "to_be_done_later";
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className = "",
}) => {
  const getBadgeContent = () => {
    switch (status) {
      case "completed":
      case "done":
      case "approved":
      case "to_be_done_later":
      case "closed":
        return {
          icon: <FeatherCheckCircle className="w-3 h-3 mr-1" />,
          text:
            status === "closed"
              ? "Closed"
              : status === "to_be_done_later"
                ? "To be done later"
                : "Completed",
          bgColor: "bg-success-100",
          borderColor: "border-success-100",
          textColor: "text-success-800",
        };
      case "in_progress":
      case "open":
        return {
          icon: <FeatherClock className="w-3 h-3 mr-1" />,
          text: status === "open" ? "Open" : "In Progress",
          bgColor: "bg-warning-100",
          borderColor: "border-warning-100",
          textColor: "text-warning-800",
        };
      case "pending_review":
      case "submitted_for_review":
        return {
          icon: <FeatherAlertCircle className="w-3 h-3 mr-1" />,
          text: "Pending Review",
          bgColor: "bg-neutral-100",
          borderColor: "border-neutral-100",
          textColor: "text-neutral-700",
        };
      case "rejected":
        return {
          icon: <FeatherAlertCircle className="w-3 h-3 mr-1" />,
          text: "Sent Back",
          bgColor: "bg-error-100",
          borderColor: "border-error-100",
          textColor: "text-error-800",
        };
      default:
        return {
          icon: null,
          text: "Not Started",
          bgColor: "bg-neutral-100",
          borderColor: "border-neutral-100",
          textColor: "text-neutral-700",
        };
    }
  };

  const { icon, text, bgColor, borderColor, textColor } = getBadgeContent();

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-md border border-solid ${borderColor} ${bgColor} px-2 py-1 ${className}`}
    >
      {icon && <span className={textColor}>{icon}</span>}
      <span className={`text-xs font-medium ${textColor}`}>{text}</span>
    </div>
  );
};

